import { UIComponentCSSStyle, UIComponentCSSStyleImpl } from '../uicomponentcss';
import { Fonts } from '../../../utils/resources/fonts';
import { Colors } from '../../../utils/resources/colors';


export interface ButtonCSSStyle extends UIComponentCSSStyle
{
    getButtonStyle(): object;
    getButtonText(): object;
}

export class ButtonCSSStyleImpl extends UIComponentCSSStyleImpl implements ButtonCSSStyle 
{ 
    getWrapperCSSStyle(): object 
    {
       return {
        position: 'relative', 
        height: '40px', 
        width: '100%', 
        cursor: "default",
        outline:'none'
      };
    }

    getButtonStyle(): object 
    {
       return {
        width:'100%',
        height: '40px',
        float: 'left', 
        borderRadius: '3px',
        overflow: 'hidden',
        backgroundColor: this.getResources().getColor(Colors.color_2),
        cursor: "pointer",
        border: 'none',
        alignContent: 'center',
        alignItems: "center",
        justifyContent: "center",
        outline:'none'
   
      };
    }

    getButtonText(): object 
    {
        return {
            color: this.getResources().getColor(Colors.color_5), 
            fontSize: this.getResources().getFont(Fonts.h6), 
            fontFamily: this.getResources().getFontFamily(), 
            lineHeight: "20px",
            textAlign: "center",
            height: "20px",
            paddingTop: "5px",
            // width: "118px",
            // textTransform: "uppercase",
            cursor: "pointer"
       };
     } 
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/button/buttoncss.tsx